import { Form, Select } from 'antd';
import React from 'react';
import { FieldDate } from 'shared/components/fields/fieldDate/FieldDate';
import {
  ResolutionFormStyled,
  ResolutionItem,
  ResolutionTitle,
} from './Resolution.styles';

interface Props {
  title: string;
}

export default function Resolution(props: Props): React.ReactElement {
  const { title } = props;

  return (
    <ResolutionItem>
      <ResolutionTitle>{title}</ResolutionTitle>
      <ResolutionFormStyled>
        <Form.Item label="Resolution">
          <Select
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Select the resolution"
          />
        </Form.Item>

        <Form.Item label="Reason">
          <Select
            showSearch
            allowClear
            optionFilterProp="children"
            placeholder="Select a reason"
          />
        </Form.Item>

        <FieldDate name="arrivalTime" label="Expires on" required={false} />
      </ResolutionFormStyled>
    </ResolutionItem>
  );
}
